import React from 'react';

import Footer from '../Footer';
import { getLayout as getBaseLayout } from './Base';
import Header from '../Header';
import ProductHuntSVG from '../../svg/icons/producthunt.svg';
import SEO from '../SEO';

const VanillaLayout = ({ children, pageContext: { page }, path, location }) => {
  const showBanner = path === '/' && process.env.GATSBY_PH_URL;

  return (
    <React.Fragment>
      <SEO {...page} location={location} />
      {showBanner && (
        <a
          className="bg-haiti flex group items-center justify-center px-6 py-4"
          href={process.env.GATSBY_PH_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ProductHuntSVG className="mr-2 text-flame-pea w-6" />
          <p className="text-sm text-white">
            We're live on Product Hunt. Join the discussion{' '}
            <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
              &#8594;
            </span>
          </p>
        </a>
      )}
      <Header path={path} />

      <div className="mt-32">
        {children}
        <Footer />
      </div>
    </React.Fragment>
  );
};

export const getLayout = (props, element) =>
  getBaseLayout(<VanillaLayout {...props}>{element}</VanillaLayout>);

export default VanillaLayout;
